"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConfirmDialog = void 0;
var tslib_1 = require("tslib");
var core_1 = require("@material-ui/core");
var react_1 = tslib_1.__importStar(require("react"));
exports.ConfirmDialog = (0, react_1.memo)(function (_a) {
    var message = _a.message, open = _a.open, onClose = _a.onClose;
    var onCloseDefault = (0, react_1.useCallback)(function () {
        onClose('no');
    }, [onClose]);
    var cancelClicked = (0, react_1.useCallback)(function () {
        onClose('no');
    }, [onClose]);
    var okClicked = (0, react_1.useCallback)(function () {
        onClose('yes');
    }, [onClose]);
    return (react_1.default.createElement(core_1.Dialog, { onClose: onCloseDefault, open: open },
        react_1.default.createElement(core_1.DialogContent, null,
            react_1.default.createElement(core_1.Typography, null, message)),
        react_1.default.createElement(core_1.DialogActions, null,
            react_1.default.createElement(core_1.Button, { onClick: cancelClicked, color: 'primary' }, "Cancel"),
            react_1.default.createElement(core_1.Button, { onClick: okClicked, color: 'secondary' }, "OK"))));
});
exports.ConfirmDialog.displayName = 'ConfirmDialog';
